import React, { useState, useEffect } from 'react';
import { CircularProgress, Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import FormSection from '../../../components/atom/FormSection';
import AuditlogTable from '../../admin/auditlog/components/AuditlogTable';
import { doSwaggerCall } from '../../../hooks/useSwaggerClient';

const BookingItemHistory = ({ bookingItemId }) => {
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(25);
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!bookingItemId) {
            return;
        }

        setLoading(true);
        setError(null);

        doSwaggerCall('bookings', 'getBookingItemHistory', { bookingItemId })
            .then(data => {
                setHistory(data.items || []);
            })
            .catch(err => {
                setError(err?.response?.body?.message || 'Failed to load history');
            })
            .finally(() => {
                setLoading(false);
            });
    }, [bookingItemId]);

    const paginatedChanges = React.useMemo(() => {
        const startIndex = page * pageSize;
        return history.slice(startIndex, startIndex + pageSize);
    }, [history, page, pageSize]);

    const handleSetPage = newPage => {
        setPage(newPage);
    };

    const handleSetPageSize = newPageSize => {
        setPageSize(newPageSize);
        setPage(0);
    };

    if (loading) {
        return (
            <FormSection title="Booking history">
                <Grid container justifyContent="center" style={{ padding: 20 }}>
                    <CircularProgress size={24} />
                </Grid>
            </FormSection>
        );
    }

    if (error) {
        return (
            <FormSection title="Booking history">
                <Alert severity="error">{error}</Alert>
            </FormSection>
        );
    }

    return (
        <FormSection title="Booking history">
            <AuditlogTable
                data={{ items: paginatedChanges }}
                total={history.length}
                page={page}
                pageSize={pageSize}
                setPage={handleSetPage}
                setPageSize={handleSetPageSize}
                hideFullLog
                hideLogDiff
            />
        </FormSection>
    );
};

export default BookingItemHistory;
